import React from 'react'
import TableHeader from '../../../../components/table/TableHeader'
import Text from '../../../../components/text/Text'
import TableLayout from '../../../../components/table/TableLayout'
import WizImage from '../../../../components/image/WizImage'
import {useImage} from '../../../../utils/image'
import {useTime} from '../../../../utils/time'
import useNavigation from '../../../../hooks/useNavigation'
import CheckTableItem from '../../../../components/table/CheckTableItem'
import {IAnnouncementList} from '../../../../apis/announce/getAnnounceList'
import {useTag} from '../../../../utils/etc'

interface IProps {
    className?: string
    data?: IAnnouncementList[]
    onChecked?: (e?: any) => void
    checkList?: any[]
}

const AnnounceListTable: React.FC<IProps> = ({className, data, onChecked, checkList}) => {
    const {renderThumbnail} = useImage()
    const {localTimeString} = useTime()
    const {goUserDetail, goAnnounceDetail} = useNavigation()
    const {announcementTagColor} = useTag()
    const onClickListItem = (list?: IAnnouncementList) => {
        goAnnounceDetail(list?.id)
    }

    const category = (item?: string) => {
        switch (item) {
            case 'announcement':
                return 'Offical'
            case 'event':
                return 'Event'
            case 'media':
                return 'Media'
            default:
                return 'Other'
        }
    }

    return (
        <div className={`${className}`}>
            <TableHeader
                className={
                    'grid-cols-[1fr_220px_220px_180px] gap-x-[10px] lg:grid-cols-[220px_1fr_160px_180px] md:hidden'
                }>
                <Text>Title/Content</Text>
                <Text>Category</Text>
                <Text>Image</Text>
                <Text className={'text-right'}>Create At</Text>
            </TableHeader>
            <TableLayout>
                {data?.map(list => (
                    <CheckTableItem
                        onClick={() => onClickListItem(list)}
                        key={list?.id}
                        checked={checkList?.find(item => item === list?.id)}
                        onChecked={() => onChecked(list?.id)}
                        className={
                            'grid-cols-[1fr_220px_220px_180px] gap-x-[10px] lg:grid-cols-[220px_1fr_160px_180px] md:block'
                        }>
                        <div className={'space-y-[10px] truncate md:mt-[30px] md:pl-[46px] sm:pl-[10px]'}>
                            <div className={'flex items-center gap-[6px]'}>
                                {list?.pin_priority > 0 && (
                                    <Text
                                        className={
                                            'shrink-0 px-[6px] py-[1px] rounded-[4px] ring-1 ring-inset ring-primary text-primary'
                                        }>
                                        📌 {list?.pin_priority}
                                    </Text>
                                )}
                                <Text className={`text-ti2 truncate`}>{list?.title}</Text>
                            </div>
                            <Text className={'truncate max-w-[500px] text-body2 text-font02 md:max-w-[100%]'}>
                                {list?.content}
                            </Text>
                        </div>
                        <div className={'flex items-center gap-[7px]'}>
                            {list?.categories?.map(item => (
                                <div className={`${announcementTagColor(item)}`}>
                                    <Text className={'text-ti2 text-center'}>{category(item)}</Text>
                                </div>
                            ))}
                        </div>
                        <div
                            className={
                                'flex space-x-[5px] items-center justify-start md:mt-[20px] md:pl-[36px] sm:pl-[0px] sm:flex-col sm:space-x-[0px] sm:gap-y-[5px]'
                            }>
                            {list?.thumbnail && (
                                <WizImage
                                    src={list?.thumbnail}
                                    alt={list?.thumbnail}
                                    isResizeFit
                                    className={`w-[198px] h-[110px] rounded-[5px] ml-[10px] lg:w-[150px] lg:h-auto`}
                                />
                            )}
                        </div>
                        <div>
                            <Text className={'text-body2 text-font02 text-right md:hidden'}>
                                {localTimeString(list?.created_at)}
                            </Text>
                        </div>
                    </CheckTableItem>
                ))}
            </TableLayout>
        </div>
    )
}

export default AnnounceListTable
